/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FufiFinancialInfoQuery,
  FufiFinancialInfoResponse,
  GetFufiInvestmentsResponse,
  GetFundsPerformanceResponse,
  GetLifeDetailResponse,
  GetLifeDetailV2Response,
  GetLifeTransactionsResponse,
  LifeTransactionEnum,
  ProductType,
  SetBeneficiariesRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FufiFinancialInfoQueryFromJSON,
    FufiFinancialInfoQueryToJSON,
    FufiFinancialInfoResponseFromJSON,
    FufiFinancialInfoResponseToJSON,
    GetFufiInvestmentsResponseFromJSON,
    GetFufiInvestmentsResponseToJSON,
    GetFundsPerformanceResponseFromJSON,
    GetFundsPerformanceResponseToJSON,
    GetLifeDetailResponseFromJSON,
    GetLifeDetailResponseToJSON,
    GetLifeDetailV2ResponseFromJSON,
    GetLifeDetailV2ResponseToJSON,
    GetLifeTransactionsResponseFromJSON,
    GetLifeTransactionsResponseToJSON,
    LifeTransactionEnumFromJSON,
    LifeTransactionEnumToJSON,
    ProductTypeFromJSON,
    ProductTypeToJSON,
    SetBeneficiariesRequestFromJSON,
    SetBeneficiariesRequestToJSON,
} from '../models/index';

export interface GetLifeDetailGetRequest {
    contractId: string;
}

export interface GetLifeDetailV2NdpGetRequest {
    contractId: string;
    proposalNumber?: string;
}

export interface GetLifeFufiFinancialInfoPostRequest {
    contractId: string;
    fufiFinancialInfoQuery?: FufiFinancialInfoQuery;
}

export interface GetLifeFufiInvestmentsGetRequest {
    contractId: string;
}

export interface GetLifeFundsGetRequest {
    contractId: string;
}

export interface GetLifeTransactionsGetRequest {
    contractId: string;
    count?: number;
    from?: Date;
    to?: Date;
    productType?: ProductType;
    typeFilter?: Array<LifeTransactionEnum>;
}

export interface SetLifeBeneficiariesPutRequest {
    contractId: string;
    setBeneficiariesRequest: SetBeneficiariesRequest;
}

/**
 * 
 */
export class ContractsLifeApi extends runtime.BaseAPI {

    /**
     * Get Life contract detail for the current user
     */
    async getLifeDetailGetRaw(requestParameters: GetLifeDetailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLifeDetailResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getLifeDetailGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/life/{contractId}`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLifeDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get Life contract detail for the current user
     */
    async getLifeDetailGet(requestParameters: GetLifeDetailGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLifeDetailResponse> {
        const response = await this.getLifeDetailGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Life contract detail for the current user v2 using NDP data
     */
    async getLifeDetailV2NdpGetRaw(requestParameters: GetLifeDetailV2NdpGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLifeDetailV2Response>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getLifeDetailV2NdpGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['proposalNumber'] != null) {
            queryParameters['proposalNumber'] = requestParameters['proposalNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/v2/life/{contractId}`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLifeDetailV2ResponseFromJSON(jsonValue));
    }

    /**
     * Get Life contract detail for the current user v2 using NDP data
     */
    async getLifeDetailV2NdpGet(requestParameters: GetLifeDetailV2NdpGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLifeDetailV2Response> {
        const response = await this.getLifeDetailV2NdpGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get FuFi financial info.
     */
    async getLifeFufiFinancialInfoPostRaw(requestParameters: GetLifeFufiFinancialInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FufiFinancialInfoResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getLifeFufiFinancialInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/life/fufi/{contractId}/financial-info`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FufiFinancialInfoQueryToJSON(requestParameters['fufiFinancialInfoQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FufiFinancialInfoResponseFromJSON(jsonValue));
    }

    /**
     * Get FuFi financial info.
     */
    async getLifeFufiFinancialInfoPost(requestParameters: GetLifeFufiFinancialInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FufiFinancialInfoResponse> {
        const response = await this.getLifeFufiFinancialInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get FuFi investments.
     */
    async getLifeFufiInvestmentsGetRaw(requestParameters: GetLifeFufiInvestmentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFufiInvestmentsResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getLifeFufiInvestmentsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/life/fufi/{contractId}/investments`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFufiInvestmentsResponseFromJSON(jsonValue));
    }

    /**
     * Get FuFi investments.
     */
    async getLifeFufiInvestmentsGet(requestParameters: GetLifeFufiInvestmentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFufiInvestmentsResponse> {
        const response = await this.getLifeFufiInvestmentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get historical values of fund units for a life contract
     */
    async getLifeFundsGetRaw(requestParameters: GetLifeFundsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFundsPerformanceResponse>>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getLifeFundsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/life/{contractId}/funds`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFundsPerformanceResponseFromJSON));
    }

    /**
     * Get historical values of fund units for a life contract
     */
    async getLifeFundsGet(requestParameters: GetLifeFundsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFundsPerformanceResponse>> {
        const response = await this.getLifeFundsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Life transaction history.
     */
    async getLifeTransactionsGetRaw(requestParameters: GetLifeTransactionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLifeTransactionsResponse>>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getLifeTransactionsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['count'] != null) {
            queryParameters['Count'] = requestParameters['count'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['From'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['to'] != null) {
            queryParameters['To'] = (requestParameters['to'] as any).toISOString();
        }

        if (requestParameters['productType'] != null) {
            queryParameters['ProductType'] = requestParameters['productType'];
        }

        if (requestParameters['typeFilter'] != null) {
            queryParameters['TypeFilter'] = requestParameters['typeFilter']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/life/{contractId}/transactions`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLifeTransactionsResponseFromJSON));
    }

    /**
     * Get Life transaction history.
     */
    async getLifeTransactionsGet(requestParameters: GetLifeTransactionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLifeTransactionsResponse>> {
        const response = await this.getLifeTransactionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set beneficiaries for life
     */
    async setLifeBeneficiariesPutRaw(requestParameters: SetLifeBeneficiariesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling setLifeBeneficiariesPut().'
            );
        }

        if (requestParameters['setBeneficiariesRequest'] == null) {
            throw new runtime.RequiredError(
                'setBeneficiariesRequest',
                'Required parameter "setBeneficiariesRequest" was null or undefined when calling setLifeBeneficiariesPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/life/{contractId}/beneficiaries`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetBeneficiariesRequestToJSON(requestParameters['setBeneficiariesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set beneficiaries for life
     */
    async setLifeBeneficiariesPut(requestParameters: SetLifeBeneficiariesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setLifeBeneficiariesPutRaw(requestParameters, initOverrides);
    }

}
